import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation("blog");

  return (
    <section className="bg-brand-cream border-b border-brand-border">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6 py-12 md:py-20">
        <h1 className="font-geist font-bold text-2xl md:text-4xl text-brand-text mb-4 md:mb-6 leading-tight">
          {t("hero.h1")}
        </h1>
        <p className="font-geist text-base md:text-lg text-brand-text/70 max-w-[720px] leading-relaxed">
          {t("hero.intro")}
        </p>
      </div>
    </section>
  );
}